<template>
  <div>
    <div class="content-section">
      <loading v-if="!ready" />
      <router-view v-if="ready" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

// import menumodal from './vue/menumodal.vue';
import loading from './vue/Loading.vue';

export default {
  name: 'Khi',
  components: {
    //  menumodal,
    loading,
  },
  data() {
    return {
      logo: '',
    };
  },
  mounted() {
    // stoße Store Ajax an....
    this.$store.dispatch('loadKurse', false);
    this.$store.dispatch('loadArten', false);
    this.$store.dispatch('loadGruppen', false);

    console.log(
      "window.location.href.indexOf( '#' )",
      window.location.href.indexOf('#'),
      window.location.href.length - 2,
    );
    if (window.location.href.indexOf('#') === window.location.href.length - 2) {
      window.location.href = `${window.location.href}gruppe/art/`;
    }
  },
  created() {
    console.log('kursbuch created, route-params:', this.$route.params);
  },
  methods: {},
  computed: {
    ...mapGetters(['ready']),
  },
};
</script>
